<template>
  <div class="page-content -column -column-two">
    <h3 class="section-title -mb">Widget</h3>

    <label class="input -checkbox -mb">
      <input v-model="resource.widget_enabled" type="checkbox" />
      Widget enabled
    </label>
    <p class="hint">When the widget is not enabled, it will not be rendered onto your webpage.</p>

    <hr />

    <label>Whitelisted Timezones</label>
    <p class="hint">Only display widget in the following timezones (shows on all timezones if empty).</p>

    <div v-for="(tz, index) in resource.whitelisted_timezones" :key="tz">
      <input v-model="tz.label" type="text" />
      <span v-if="dig(errors.whitelisted_timezones, index)" class="alert -inline -danger">
        {{ [...dig(errors.whitelisted_timezones, index, 'label')].join(', ') }}
      </span>
      <a href="#" class="button -small -danger -mb" @click.prevent="removeTimezone(tz)">Remove timezone</a>
    </div>

    <a href="#" class="button -small" @click.prevent="addTimezone">Add timezone</a>

    <action-button class="-mt" :text="'Update Settings'" :state="state" @pressed="submit"></action-button>

    <hr />

    <h3 class="section-title -mb -mt">Embed Code</h3>

    <pre><code ref="codeBlock" class="js">
&lt;script type="text/javascript" src="https://widget.ripley.chat/js/app.js"&gt;&lt;/script&gt;

&lt;script type="text/javascript"&gt;
new RipleyChat({
  teamId: "{{ currentTeamHashid }}",
  uid: "12345",
  context: {
    title: "Chat title",
    url: "Current page URL",
    image: "Chat image URL",
    dealership: { id: {{ dealerships.length ? dealerships[0].id : '513746' }} }
    // ... any additional custom context
  }
});
&lt;/script&gt;
    </code></pre>
  </div>
</template>

<script>
import hljs from "highlight.js";
import dig from "object-dig";
import _ from "underscore";
import { mapGetters, mapState } from "vuex";

import actionButton from "@/components/actionButton";
import settingsBase from "@/components/settings/base.vue";

export default {
  components: { actionButton },
  extends: settingsBase,

  data() {
    return {
      fields: ["widget_enabled", "whitelisted_timezones"]
    };
  },

  computed: {
    ...mapState({
      dealerships: (state) => state.dealerships.all
    }),
    ...mapGetters(["currentTeam"]),
    currentTeamHashid() {
      return this.currentTeam.hashid;
    }
  },

  created() {
    this.highlightCode();
  },

  methods: {
    dig,

    highlightCode() {
      this.$nextTick(() => {
        hljs.highlightBlock(this.$refs.codeBlock);
      });
    },

    addTimezone() {
      const dupe = _.clone(this.resource);
      dupe.whitelisted_timezones.push({ label: '' });
      this.resource = dupe;
    },

    removeTimezone(tz) {
      const dupe = _.clone(this.resource);
      dupe.whitelisted_timezones = _.without(dupe.whitelisted_timezones, tz);
      this.resource = dupe;
    }
  }
};
</script>
